import { BoundingBox3 } from '@/editor/math/BoundingBox3';
import { IAssemblyData } from '../assembly/assembly';
import { IFurniture } from '../model/furniture';
import { getModelBoundingBox } from '../utils';
import { Euler, Matrix4, Vector3 } from 'three';
import { IModelGroupData } from './modelGroup';
import { getUniqueId } from '@/editor/utils';
import { EModelGroupType } from '../type';

export function createModelGroupData(
  baseData: IFurniture | IAssemblyData,
  datas: (IFurniture | IAssemblyData)[],
  modelType: EModelGroupType,
  xSpace: number,
  ySpace: number
) {
  const modelGroupBoundingBox = new BoundingBox3();
  for (const data of datas) {
    const box = getModelBoundingBox(data);
    const points = box.points;
    modelGroupBoundingBox.includePoints(points);
  }

  const min = modelGroupBoundingBox.min;
  const max = modelGroupBoundingBox.max;
  const width = max.x - min.x;
  const thickness = max.y - min.y;
  const height = max.z - min.z;
  const offGround = min.z;
  const center = new Vector3((min.x + max.x) / 2, (min.y + max.y) / 2, (min.z + max.z) / 2);

  const euler = new Euler(0, 0, 0); // XYZ顺序
  const matrix = new Matrix4();
  matrix.makeRotationFromEuler(euler);
  matrix.setPosition(center);

  const modelGroupData: IModelGroupData = {
    id: getUniqueId(),
    baseModel: baseData,
    accessorieIds: datas.map((data) => data.id),
    modelType,
    xSpace,
    ySpace,
    matrix,
    center: { x: center.x, y: center.y },
    rotation: 0,
    offGround,
    width,
    thickness,
    height
  };

  return modelGroupData;
}
